import type { Report } from '@/types';

export const mockReports: Report[] = [
  {
    id: 'rep_1',
    name: 'Monthly Sales Summary',
    dashboardId: 'dash_1',
    format: 'pdf',
    schedule: 'monthly',
    recipients: ['finance@example.com', 'managers@example.com'],
    lastRunAt: '2026-06-01T02:00:00.000Z',
    status: 'completed',
    nextRunAt: '2026-07-01T02:00:00.000Z',
    createdAt: '2026-01-15T10:00:00.000Z',
    updatedAt: '2026-06-01T02:00:00.000Z',
  },
  {
    id: 'rep_2',
    name: 'Weekly KPI Report',
    dashboardId: 'dash_1',
    format: 'excel',
    schedule: 'weekly',
    recipients: ['team@example.com'],
    lastRunAt: '2026-07-06T06:00:00.000Z',
    status: 'completed',
    nextRunAt: '2026-07-13T06:00:00.000Z',
    createdAt: '2026-02-01T08:00:00.000Z',
    updatedAt: '2026-07-06T06:00:00.000Z',
  },
  {
    id: 'rep_3',
    name: 'Daily Revenue Export',
    dashboardId: 'dash_2',
    format: 'csv',
    schedule: 'daily',
    recipients: ['ops@example.com'],
    lastRunAt: '2026-07-08T23:59:00.000Z',
    status: 'completed',
    nextRunAt: '2026-07-09T23:59:00.000Z',
    createdAt: '2026-03-10T09:00:00.000Z',
    updatedAt: '2026-07-08T23:59:00.000Z',
  },
  {
    id: 'rep_4',
    name: 'Executive Dashboard Snapshot',
    dashboardId: 'dash_1',
    format: 'pdf',
    schedule: 'weekly',
    recipients: ['ceo@example.com', 'execs@example.com'],
    lastRunAt: '2026-07-05T08:00:00.000Z',
    status: 'completed',
    nextRunAt: '2026-07-12T08:00:00.000Z',
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-07-05T08:00:00.000Z',
  },
  {
    id: 'rep_5',
    name: 'Ad-hoc Campaign Analysis',
    dashboardId: 'dash_3',
    format: 'excel',
    schedule: 'once',
    recipients: ['marketing@example.com'],
    status: 'pending',
    createdAt: '2026-07-08T14:30:00.000Z',
    updatedAt: '2026-07-08T14:30:00.000Z',
  },
  {
    id: 'rep_6',
    name: 'Quarterly Financial Review',
    dashboardId: 'dash_2',
    format: 'pdf',
    schedule: 'monthly',
    recipients: ['finance@example.com'],
    lastRunAt: '2026-07-01T03:00:00.000Z',
    status: 'completed',
    nextRunAt: '2026-08-01T03:00:00.000Z',
    createdAt: '2026-04-01T10:00:00.000Z',
    updatedAt: '2026-07-01T03:00:00.000Z',
  },
  {
    id: 'rep_7',
    name: 'User Activity Log',
    dashboardId: 'dash_3',
    format: 'csv',
    schedule: 'daily',
    recipients: ['support@example.com'],
    lastRunAt: '2026-07-08T04:00:00.000Z',
    status: 'completed',
    nextRunAt: '2026-07-09T04:00:00.000Z',
    createdAt: '2026-05-15T12:00:00.000Z',
    updatedAt: '2026-07-08T04:00:00.000Z',
  },
  {
    id: 'rep_8',
    name: 'Project Milestone Report',
    dashboardId: 'dash_3',
    format: 'pdf',
    schedule: 'weekly',
    recipients: ['pm@example.com', 'stakeholders@example.com'],
    lastRunAt: '2026-07-06T09:00:00.000Z',
    status: 'failed',
    nextRunAt: '2026-07-13T09:00:00.000Z',
    createdAt: '2026-06-01T08:00:00.000Z',
    updatedAt: '2026-07-06T09:00:00.000Z',
  },
];
